// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ConfirmEntryReportResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for PUT /so/orders/confirm_entry_report
 *
 * Returns the entry report id and a confirmation flag.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_ConfirmEntryReportResponseDados {
report_id: number
confirmed: boolean
}

export type Orders_ConfirmEntryReportResponse = ApiResponse<Orders_ConfirmEntryReportResponseDados>;

registerResponseContract('Orders_ConfirmEntryReportResponse', {
  report_id: { type: 'number',  required: true },
  confirmed: { type: 'boolean', required: true },
})
